import type {
  PropertyListCityOption,
  PropertyListConsultantOption,
} from "./usePropertyListFilterOptions";

export const PROPERTY_LIST_EXACT_COUNT_FILTER_MAX = 10;

export const PROPERTY_LIST_FURNISHED_FILTERS = [
  { value: "", label: "Todos" },
  { value: "1", label: "Mobiliado" },
  { value: "2", label: "Semimobiliado" },
  { value: "0", label: "Não mobiliado" },
] as const;

export const PROPERTY_LIST_COMMISSION_FILTERS = [
  { value: "", label: "Todos" },
  { value: "admin_7cantos", label: "Gerenciado pela 7Cantos (ADM)" },
  { value: "partnership", label: "Parceria" },
  { value: "none", label: "Imóvel solto" },
] as const;

export function buildExactCountFilterOptions(
  currentValue: string,
  options?: { includeZero?: boolean; zeroLabel?: string }
) {
  const countOptions = [
    { value: "", label: "Todos" },
    ...(options?.includeZero
      ? [{ value: "0", label: options.zeroLabel ?? "0" }]
      : []),
    ...Array.from(
      { length: PROPERTY_LIST_EXACT_COUNT_FILTER_MAX },
      (_, index) => {
        const value = String(index + 1);
        return { value, label: value };
      }
    ),
  ];

  return withCurrentFilterOption(countOptions, currentValue);
}

export function withCurrentFilterOption(
  options: Array<{ value: string; label: string }>,
  currentValue: string
) {
  if (!currentValue || options.some((option) => option.value === currentValue)) {
    return options;
  }
  return [...options, { value: currentValue, label: currentValue }];
}

export function buildCityFilterOptions(
  cities: PropertyListCityOption[],
  currentCity: string
) {
  return withCurrentFilterOption(
    [
      { value: "", label: "Todas" },
      ...cities
        .filter((item) => item.city)
        .map((item) => ({
          value: item.city,
          label: item.uf ? `${item.city} - ${item.uf}` : item.city,
        })),
    ],
    currentCity
  );
}

export function buildConsultantFilterOptions(
  consultants: PropertyListConsultantOption[],
  currentConsultantId: string
) {
  return withCurrentFilterOption(
    [
      { value: "", label: "Todos" },
      ...consultants.map((consultant) => ({
        value: String(consultant.id),
        label: consultant.first_name || `Consultor ${consultant.id}`,
      })),
    ],
    currentConsultantId
  );
}
